import { productPlaceholder } from '@/lib/placeholders';
import { Section, SectionItem, SectionItemData } from '@/types';
import uniqueId from 'lodash/uniqueId';
import Image from 'next/image';
import Link from '../ui/link';

interface SectionComponentProps {
  section: Section;
}

const SectionComponent: React.FC<SectionComponentProps> = ({ section }) => {
  return (
    <div className="mb-4 grid grid-cols-12 gap-4">
      {section.items.map((item: SectionItem) => (
        <div
          key={uniqueId('item-')}
          className={`col-span-12 rounded-lg bg-light shadow-downfall-sm md:col-span-${item.no_of_columns * 2}`}
        >
          {item.type === 'category' && item.data && (
            <>
              <div className="flex items-center justify-between border-b border-b-border-200 p-4">
                <h3 className="font-bold uppercase">{item.title}</h3>
                {item.link?.url && (
                  <Link
                    href={item.link.url}
                    className="flex items-center text-sm text-blue-600 hover:text-blue-800"
                  >
                    {item.link.title || 'View More'}
                  </Link>
                )}
              </div>
              <div
                className={`grid grid-cols-2 gap-3 p-4 md:grid-cols-${item.no_of_columns}`}
              >
                {item.data.map((dataItem: SectionItemData) => (
                  <Link
                    href={`/search?category=${dataItem.slug}`}
                    key={uniqueId('item-section-')}
                    className="flex h-[12rem] flex-col rounded-lg border border-gray-200 text-center shadow-downfall-sm transition-all duration-200 hover:shadow-downfall-lg lg:h-[16.5rem]"
                  >
                    <div className="relative flex-1 overflow-hidden">
                      <Image
                        src={dataItem.image?.original ?? productPlaceholder}
                        alt={dataItem.name}
                        width={150}
                        height={150}
                        className="h-full w-full rounded-t-md border-b object-cover"
                      />
                    </div>
                    <p className="truncate p-2 text-sm font-semibold">
                      {dataItem.name}
                    </p>
                  </Link>
                ))}
              </div>
            </>
          )}
          {item.type === 'image' && item.image && (
            <Link href={item.link?.url || '/'}>
              <Image
                src={item.image.original}
                alt={item.title}
                width={item.no_of_columns * 115}
                height={item.no_of_rows * 140}
                className="h-full w-full rounded-md object-cover shadow-downfall-sm transition-all duration-200 hover:shadow-downfall-lg"
              />
            </Link>
          )}
        </div>
      ))}
    </div>
  );
};

export default SectionComponent;
